<template>

  <BasicLayout>

    <div>

      <!-- SEARCH -->
      <Search :searching="searching"
              @search="search"
              @closeSearch="searching = false"
              @clearSearch="clearSearch"/>

      <div class="elevation-2">

        <!-- TOOLBAR -->
        <v-toolbar flat="flat">
          <v-toolbar-title>Teams</v-toolbar-title>
          <v-flex class="ml-5" md3="md3">
            <v-text-field v-show="!loading && !searching"
                          v-model="quickSearchID"
                          placeholder="Search by ID"
                          :clearable="true"></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-icon class="mr-2"
                  v-if="!searching"
                  title="Show the search"
                  @click="searching = true">mdi-magnify</v-icon>
          <v-icon title="Create club"
                  @click="dialog = true">mdi-plus</v-icon>
        </v-toolbar>

        <!-- TABLE -->
        <Table :headers="headers"
               :items="items"
               :pagination="pagination"
               :paginationOptions="paginationOptions"
               :totalItems="pagination.totalItems"
               :loading="loading"
               @paginationUpdate="paginationUpdate"
               @edit="toggleEdit"
               @del="del"/>

        <!-- CREATE / EDIT -->
        <Dialog :dialog="dialog"
                :dialogState="dialogState"
                :currentEditedTeam="editedItem"
                :errorMessage="errorMessage"
                @dialogClosed="close"
                @createTeam="createTeam"
                @editTeam="editTeam"/>

      </div>
    </div>

    <!-- CONFIRM DELETE TEAM WITH VIDEOS -->
    <ConfirmPopup :isActive="deleteConfirmToggled"
                  :title="'Warning : this team has videos'"
                  :text="'If you confirm delete, all videos on this team will be deleted\n\nThis action is irreversible'"
                  :cancelButtonText="'Cancel'"
                  :confirmButtonText="'Delete'"
                  @cancel="cancelDeleteConfirm"
                  @confirm="confirmDeleteConfirm"/>

  </BasicLayout>

</template>

<script>

import BasicLayout from '../layouts/BasicLayout'
import Search from '../components/teams/Search'
import Table from '../components/teams/Table'
import Dialog from '../components/teams/Dialog'
import ConfirmPopup from '../components/common/ConfirmPopup'

export default {
  name: 'TeamsPage',
  components: {
    BasicLayout,
    Search,
    Table,
    Dialog,
    ConfirmPopup
  },
  data () {
    return {
      loading: false,

      items: [],

      headers: [
        {
          text: 'ID',
          value: 'id',
          sortable: false,
          width: '1%'
        },
        {
          text: 'Name',
          value: 'name',
          sortable: false,
          width: '200px'
        },
        {
          text: 'Sport',
          value: 'sportID',
          sortable: false,
          width: '1%'
        },
        {
          text: 'Federation',
          value: 'federationID',
          sortable: false,
          width: '120px'
        },
        {
          text: 'Category',
          value: 'categoryName',
          sortable: false,
          width: '120px'
        },
        {
          text: 'Club',
          value: 'clubAlias',
          sortable: false,
          width: '200px'
        }
      ],

      pagination: {
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
      },
      paginationOptions: [10, 50, 100],

      dialog: null,
      editedItem: null,
      editedIndex: -1,

      errorMessage: '',

      quickSearchID: null,

      searching: false,
      searchParams: {},

      deleteConfirmToggled: false,
      deleteConfirmTeam: null
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.loading = true
      this.searching = false

      let params = {
        page: this.pagination.page - 1,
        pageSize: this.pagination.rowsPerPage,
        withTotalItems: true,
        avoidCache: true
      }

      if (this.searchParams.name) {
        params.name = this.searchParams.name
      }
      if (this.searchParams.sportID) {
        params.sportID = this.searchParams.sportID
      }
      if (this.searchParams.federationID) {
        params.federationID = this.searchParams.federationID
      }
      if (this.searchParams.clubID) {
        params.clubID = this.searchParams.clubID
      }
      if (this.searchParams.categoryAge) {
        params.categoryAge = this.searchParams.categoryAge
      }
      if (this.searchParams.categoryGender) {
        params.categoryGender = this.searchParams.categoryGender
      }

      this.$store.dispatch('searchTeams', params)
        .then(resp => {
          this.pagination.totalItems = resp.totalItems
          this.items = resp.items
          this.loading = false
        })
        .catch(() => {
          alert('Error loading teams')
          this.loading = false
        })
    },

    search (params) {
      this.pagination = {
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
      }
      this.searchParams = params
      this.loadData()
    },

    clearSearch () {
      this.searchParams = {
        name: null,
        sportID: null
      }
    },

    toggleEdit (index) {
      this.editedIndex = index
      this.editedItem = JSON.parse(JSON.stringify(this.items[index]))
      this.dialog = true
    },

    close () {
      this.dialog = false
      this.editedItem = null
      this.editedIndex = -1
      this.errorMessage = ''
    },

    createTeam (team, federationID) {
      if (this.checkFields(team)) {
        return
      }

      this.$store.dispatch('getFederationCategories', federationID)
        .then(resp => {
          let category = resp.filter(item => item.age === team.categoryAge && item.gender === team.categoryGender)
          if (category.length === 1) {
            let params = {
              ...team
            }
            params.categoryID = category[0].id
            delete params.categoryAge
            delete params.categoryGender
            this.$store.dispatch('createTeam', params)
              .then(resp => {
                this.showCreatedTeam(resp.id)
                this.close()
              })
              .catch(() => {
                alert('Error creating team')
              })
          } else {
            this.errorMessage = 'Error with category'
          }
        })
        .catch(() => {
          alert('error getting categories')
        })
    },

    showCreatedTeam (id) {
      this.$store.dispatch('getTeam', id)
        .then(resp => {
          this.items = [resp]
        })
    },

    editTeam (team, federationID) {
      if (this.checkFields(team)) {
        return
      }

      this.$store.dispatch('getFederationCategories', federationID)
        .then(resp => {
          let category = resp.filter(item => item.age === team.categoryAge && item.gender === team.categoryGender)
          if (category.length === 1) {
            let params = {
              ...team
            }
            params.categoryID = category[0].id
            delete params.categoryAge
            delete params.categoryGender

            this.$store.dispatch('patchTeam', {
              id: this.items[this.editedIndex].id,
              patch: params
            })
              .then(() => {
                this.updateItem(this.editedIndex, team)
                this.close()
              })
              .catch(() => {
                alert('Error editing team')
              })
          } else {
            this.errorMessage = 'Error with category'
          }
        })
        .catch(() => {
          alert('error getting categories')
        })
    },

    updateItem (index, patch) {
      this.items[index].name = patch.name
      this.items[index].sportID = patch.sportID
      this.items[index].federationID = patch.federationID
      this.items[index].clubID = patch.clubID
      this.items[index].categoryAge = patch.categoryAge
      this.items[index].categoryGender = patch.categoryGender
    },

    del (team) {
      this.$store.dispatch('deleteTeam', team.id)
        .then(() => {
          this.loadData()
        })
        .catch(err => {
          if (err.response.status === 409) {
            this.deleteConfirmToggled = true
            this.deleteConfirmTeam = team
          } else {
            alert('Error deleting team')
          }
        })
    },
    cancelDeleteConfirm () {
      this.deleteConfirmClub = null
      this.deleteConfirmToggled = false
    },
    confirmDeleteConfirm () {
      this.$store.dispatch('confirmDeleteTeam', this.deleteConfirmTeam.id)
        .then(() => {
          this.deleteConfirmTeam = null
          this.deleteConfirmToggled = false
          this.loadData()
        })
        .catch(() => {
          alert('Error deleting team')
        })
    },

    checkFields (team) {
      if (!team.name) {
        this.errorMessage = 'Please enter a name'
        return true
      }

      if (!team.clubID) {
        this.errorMessage = 'Please select a club'
        return true
      }

      if (!team.categoryAge) {
        this.errorMessage = 'Please select an age'
        return true
      }

      if (!team.categoryGender) {
        this.errorMessage = 'Please select a gender'
        return true
      }

      return false
    },

    paginationUpdate (v) {
      if (this.pagination.page !== v.page || this.pagination.rowsPerPage !== v.rowsPerPage) {
        this.pagination = {
          page: v.page,
          rowsPerPage: v.rowsPerPage,
          totalItems: this.pagination.totalItems
        }
        this.loadData()
      }
    }
  },
  computed: {
    dialogState () {
      return this.editedIndex === -1 ? 'create' : 'edit'
    }
  },
  watch: {
    'quickSearchID' () {
      if (this.quickSearchID) {
        if (this.quickSearchID.length !== 20) {
          this.quickSearchID = null
          return
        }
        this.loading = true
        this.$store.dispatch('getTeam', this.quickSearchID)
          .then(resp => {
            this.items = [resp]
            this.loading = false
          })
          .catch(() => {
            this.loading = false
            alert('Error loading team')
          })
      } else {
        this.loadData()
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/TeamsPage.vue